import Config from "../../service/auth/config.js";

export default class Token extends Config {


  isTokenExpired() {
    let token = this.token();
    // tokenData é o objeto JSON que você passou
    const now = Date.now(); // tempo atual em milissegundos
    if (token === null) {
      return true;
    } else {
      return token.expireDate <= now;
    }
  }

  /** limpar token **/
  clearAccessToken() {
    localStorage.removeItem("token_cer");
  }

  /** armazenaToken **/
  storeToken(token) {
    localStorage.setItem("token_cer", JSON.stringify(token));
  }

  /** retorna token **/
  token() {
    let token = localStorage.getItem("token_cer");
    token = JSON.parse(token);
    return token;
  }

  /** token valido **/
  checkToken() {
    return new Promise((resolve, reject) => {
      const msg = "Tempo de sessão encerrado. Para continuar efetue login novamente!";
      if (this.isTokenExpired()) {
        // Sessão expirada
        reject(msg);
      } else {
        resolve(); // Token válido
      }
    });
  }
}
